import React, { useState } from "react";
import { ArrowRightOutlined, DeleteOutlined } from "@ant-design/icons";

import axiosSession from "@app/config/axiosSession";
import useGenericToastify from "@app/hooks/useGenericToastify";
import CMSTable from "@components/Table/CMSTable";
import Modal from "../assets/Modal/Modal";
import { useTranslation } from "react-i18next";
import { Space } from "antd";

const Highlightings = () => {
  const { t } = useTranslation();
  const [itemData, setItemData] = useState({});
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const { notifySuccess, notifyError } = useGenericToastify();
  const [shouldTableRefresh, setShouldTableRefresh] = useState(false);
  const [CMSTableView, setCMSTableView] = useState("table");

  const columns = [
    {
      title: t("cms.plugins.highlightings.structure.title"),
      dataIndex: "name",
      key: "digital_item__name",
      sorter: true,
      width: "30%"
    },
    {
      title: t("cms.plugins.highlightings.structure.content"),
      dataIndex: "content",
      key: "content",
      sorter: true,
      width: "30%"
    },
    {
      title: t("cms.plugins.notes.structure.page"),
      dataIndex: "page_number",
      key: "page_number",
      sorter: true,
      width: "6%"
    },
    {
      title: t("cms.plugins.notes.structure.created"),
      dataIndex: "created",
      key: "created",
      sorter: true,
      width: "15%"
    },
    {
      title: t("cms.plugins.notes.structure.actions"),
      dataIndex: "",
      sorter: false,
      width: "8%",
      fixed: "right",
      render: (text, record) => (
        <Space
          size="small"
          direction={CMSTableView === "list" ? "vertical" : "horizontal"}
        >
          <a
            className="btn btn--text-black"
            href={record.url}
            title={t("cms.plugins.highlightings.action")}
            aria-label={t("cms.plugins.highlightings.action")}
          >
            <ArrowRightOutlined className="anticon-dark" aria-hidden="true" />{" "}
            {CMSTableView === "list" && t("cms.plugins.highlightings.action")}
          </a>
          <button
            className="btn btn--text-black"
            title={t("cms.plugins.bookmarks.actions.delete")}
            aria-label={t("cms.plugins.bookmarks.actions.delete")}
            onClick={() => onDelete(record)}
          >
            <DeleteOutlined className="anticon-dark" aria-hidden="true" />{" "}
            {CMSTableView === "list" &&
              t("cms.plugins.bookmarks.actions.delete")}
          </button>
        </Space>
      )
    }
  ];

  const message = {
    btnDeleteNo: t("cms.plugins.highlightings.message.btnDeleteNo"),
    btnDeleteYes: t("cms.plugins.highlightings.message.btnDeleteYes"),
    headerTitle: t("cms.plugins.highlightings.message.headerTitle"),
    bodyContent: t("cms.plugins.highlightings.message.bodyContent")
  };

  const urls = {
    get: "/api/attributes/user/highlighting/"
  };

  const tableMessages = {
    pagination: {
      show: t("app.table.pagination.show"),
      results: t("app.table.pagination.results"),
      goto: t("app.table.pagination.goto")
    },
    search: {
      button: t("app.table.search.button"),
      placeholder: t("app.table.search.placeholder")
    },
    loading: t("app.table.loading"),
    noItems: t("cms.plugins.highlightings.noItems"),
    fetchError: t("app.table.fetchError")
  };

  const onDelete = item => {
    setItemData({ id: item.pk, name: item.name });
    setModalIsOpen(true);
  };

  const onConfirmDelete = id => {
    axiosSession
      .delete(`/api/attributes/user/annotations/${id}/`)
      .then(() => {
        notifySuccess(t("cms.plugins.highlightings.message.deleteSuccess"));
        setShouldTableRefresh(true);
      })
      .catch(err => {
        notifyError(t("cms.plugins.highlightings.message.deleteError"));
        console.error(err);
      })
      .finally(() => {
        setModalIsOpen(false);
        setShouldTableRefresh(false);
      });
  };

  return (
    <>
      <Modal
        open={modalIsOpen}
        onClose={() => setModalIsOpen(false)}
        title={t("cms.plugins.highlightings.message.headerTitle")}
        content={
          <div className="only-text" key={itemData.id}>
            <DeleteOutlined />
            <span>{t("cms.plugins.highlightings.message.bodyContent")}</span>
          </div>
        }
        buttons={
          <>
            <button
              className="btn btn--text"
              onClick={() => setModalIsOpen(false)}
              onKeyPress={() => setModalIsOpen(false)}
            >
              {t("cms.plugins.highlightings.message.btnDeleteNo")}
            </button>
            <button
              className="btn"
              onClick={() => onConfirmDelete(itemData.id)}
            >
              {t("cms.plugins.highlightings.message.btnDeleteYes")}
            </button>
          </>
        }
      />
      <CMSTable
        columns={columns}
        dataUrl={urls.get}
        listView
        shouldTableRefresh={shouldTableRefresh}
        setUpperView={setCMSTableView}
      />
    </>
  );
};

export default Highlightings;
